import styled from "styled-components";

export const InfoContainer = styled.div`
  color: var(--white);
  /* height: 70vh; */
  background: ${({ lightBg }) => (lightBg ? "var(--white)" : "var(--black)")};
`;

export const InfoWrapper = styled.div`
  display: grid;
  z-index: 1;
  min-height: 75vh;

  height: 860px;
  width: 100%;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 24px;
  justify-content: center;

  @media screen and (max-width: 600px) {
    height: auto;
    padding: 70px;
  }

  @media screen and (max-width: 400px) {
    height: auto;
    padding: 70px;
  }
`;

export const InfoRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  align-items: center;
  grid-template-areas: ${({ imgStart }) =>
    imgStart ? `'col2 col1'` : `'col1 col2'`};
  @media screen and (max-width: 600px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`};
  }
`;

export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;
`;

export const TopLine = styled.p`
  color: var(--blue);
  font-size: 24px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: ${({ lowercase }) => (lowercase ? "lowercase" : "none")};
  margin-bottom: 16px;
  line-height: 1.1;
  @media screen and (max-width: 400px) {
    font-size: 20px;
  }
`;

export const TopLineMax = styled.span`
  color: ${({ lightText }) => (lightText ? "var(--white)" : "var(--black)")};
  font-size: 24px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: lowercase;
  margin-bottom: 16px;
  @media screen and (max-width: 400px) {
    font-size: 20px;
  }
`;
export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? "var(--white)" : "var(--black)")};
  @media screen and (max-width: 768px) {
    font-size: 32px;
  }
  @media screen and (max-width: 400px) {
    font-size: 28px;
  }
`;

export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: ${({ darkText }) => (darkText ? "var(--black)" : "var(--white)")};
  text-indent: ${({listIndent}) => (listIndent ? "5%" : "0%")};
  @media screen and (max-width: 400px) {
    font-size: 15px;
  }
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;

export const Img = styled.img`
  width: 100%;

  max-height: ${({ imgSize }) => (imgSize ? imgSize : "auto")};
  margin: 0 0 10px 0;
  padding-right: 0;
`;
